import { render, staticRenderFns } from "./OrderProduct.vue?vue&type=template&id=ad10c498&scoped=true&"
import script from "./OrderProduct.vue?vue&type=script&lang=js&"
export * from "./OrderProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderProduct.vue?vue&type=style&index=0&id=ad10c498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad10c498",
  null
  
)

export default component.exports